import { Component, OnInit } from '@angular/core';

import { DomSanitizer } from '@angular/platform-browser';

import { NbDialogRef } from '@nebular/theme';
import { Router } from '@angular/router';
import { downloadFileUtil } from '../../../../shared/utils/file-downloader';
import { InstitutionService } from '../../Service/InstitationService';
import { Institation } from '../../Model/institution';

@Component({
  selector: 'institution-details',
  templateUrl: './institution-details.component.html',
  styleUrls: ['./institution-details.component.scss']
})


export class InstitutionDetailsComponent implements OnInit {
  model = {} as Institation;
  constructor(
    private sanitizer: DomSanitizer,
    private service: InstitutionService,
    private diag: NbDialogRef<InstitutionDetailsComponent>,
    private route : Router
  ) {}

  getLabelData(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diag.close('false');
     }); 
  }
  downloadFile(fileName) {
    this.service.downloadFile(fileName).subscribe((blob) => {
      downloadFileUtil(blob, fileName);
    });
  }

  close() {
    this.diag.close();
  }
}
